import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

const ManageLocality = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [designations, setDesignations] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editID, setEditID] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({ city: "", name: "" });
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const filter = () => {
    if (!filterText) {
      setFilteredData(designations);
      return;
    }

    const arr = designations?.filter((e) => {
      const cityName = e?.city?.toLowerCase() || "";
      const localityName = e?.name?.toLowerCase() || "";
      const searchText = filterText.toLowerCase();

      return cityName.includes(searchText) || localityName.includes(searchText);
    });
    setFilteredData(arr);
  };

  useEffect(() => {
    filter();
  }, [filterText, designations]);

  const [allCities, setAllCities] = useState([]);
  const [allLocalities, setAllLocalities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedLocality, setSelectedLocality] = useState("");

  const fetchAllCities = async () => {
    try {
      const res = await HomeService.getCities();
      console.log("cities", res);
      if (res?.status) {
        setAllCities(res?.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to load cities!");
    }
  };

  const fetchAllLocalities = async () => {
    try {
      const res = await HomeService.getLocalities();
      console.log("Localities", res);
      if (res?.status) {
        setAllLocalities(res?.data);
      }
    } catch (error) {
      console.error("Error fetching Localities:", error);
      toast.error("Failed to load Localities!");
    }
  };

  useEffect(() => {
    fetchAllCities();
    fetchAllLocalities();
  }, []);

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true, width: "10%" },
    { name: "City", selector: (row) => row.city, sortable: true, width: "40%" },
    {
      name: "Locality",
      selector: (row) => row.name,
      sortable: true,
      width: "40%",
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span title="Delete" onClick={() => handleDelete(row.id)}>
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data);
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getLocalities();
      const arr = res?.data?.map((ele, ind) => ({
        sln: ind + 1,
        city: ele?.city?.name,
        cityId: ele?.city?._id,
        name: ele.name,
        id: ele._id,
      }));
      setDesignations(arr);
      if (userCity) {
        setDesignations(arr.filter((item) => item?.cityId === userCity));
      }
    } catch (error) {
      console.error("Error fetching locality:", error);
      toast.error("Failed to load locality!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({ city: row.cityId, name: row.name });
    setEditID(row.id);
  };

  console.log("HTR103", editData);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Locality?",
      text: "Are you sure you want to delete this locality?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteLocality(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Locality has been deleted.", "success");
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Locality.", "error");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { city: editData.city, name: editData.name };
      if (isEdit) {
        const res = await HomeService.updateLocality(editID, data);
        if (res?.status) {
          toast.success("Locality updated successfully!");
          setIsEdit(false);
          setEditData({ city: "", name: "" });
          fetchAllData();
        }
      }
    } catch (error) {
      toast.error("Failed to save locality.");
      console.error("Error saving locality:", error);
    }
  };

  useEffect(() => {
    fetchCities();
  }, []);

  const handleFilter = async () => {
    try {
      const res = await HomeService?.filterLocality({
        cityId: selectedCity,
        localityId: selectedLocality,
      });
      console.log("filtered locality", res);
      if (res?.status) {
        const arr = res?.data?.map((ele, ind) => ({
          sln: ind + 1,
          city: ele?.city?.name,
          cityId: ele?.city?._id,
          name: ele.name,
          id: ele._id,
        }));
        setDesignations(arr);
      }
    } catch (error) {
      toast.error("Failed to get locality.");
      console.error("Error getting locality:", error);
    }
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div className="mt-5">
            <div style={headLineStyle} className="page-headline">
              Manage Locality
            </div>
            <div style={{ margin: "15px 0" }}>
              <input
                style={{
                  width: "25%",
                  height: "35px",
                  padding: "0 5px",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "#dae3f2",
                  marginRight: "5px",
                }}
                value={filterText}
                onChange={(e) => {
                  setFilterText(e?.target?.value);
                }}
                placeholder="Search by city or locality..."
              />
              {console.log("cities2", cities)}
              <select
                style={{
                  width: "25%",
                  height: "35px",
                  padding: "0 5px",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "#dae3f2",
                  marginRight: "5px",
                }}
                onChange={(e) => {
                  setSelectedCity(e?.target?.value);
                }}
              >
                <option>--- Select City ---</option>
                {allCities?.length === 0 ? (
                  <option>No City Fund</option>
                ) : (
                  allCities?.map((e, i) => {
                    return <option value={e?._id}>{e?.name}</option>;
                  })
                )}
              </select>
              <select
                style={{
                  width: "25%",
                  height: "35px",
                  padding: "0 5px",
                  borderRadius: "5px",
                  border: "none",
                  backgroundColor: "#dae3f2",
                  marginRight: "5px",
                }}
                disabled={!selectedCity}
                onChange={(e) => {
                  setSelectedLocality(e?.target?.value);
                }}
              >
                <option value="">--- Select Locality ---</option>
                {allLocalities?.length === 0 ? (
                  <option>No Locality Fund</option>
                ) : (
                  allLocalities
                    ?.filter((e, i) => e?.city?._id == selectedCity)
                    .map((e, i) => {
                      return <option value={e?._id}>{e?.name}</option>;
                    })
                )}
              </select>
              <button
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#34eb34",
                  color: "black",
                  width: "80px",
                  borderRadius: "5px",
                  border: "none",
                  fontWeight: "600",
                }}
                onClick={() => {
                  handleFilter();
                }}
              >
                Filter
              </button>
            </div>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {isEdit ? (
                  <section className="chartBox_area">
                    <h2>View/Modify Locality Details</h2>
                    <hr />
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-4 mt-3">
                          <label>
                            City<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="city"
                            value={editData.city}
                            onChange={(e) =>
                              setEditData({ ...editData, city: e.target.value })
                            }
                            required
                          >
                            <option value="" disabled>
                              ---Select---
                            </option>
                            {cities.map((city) => (
                              <option key={city._id} value={city._id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-8 mt-3">
                          <label htmlFor="name">
                            Locality Name<span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            id="name"
                            className="form-control"
                            value={editData.name}
                            onChange={(e) =>
                              setEditData({ ...editData, name: e.target.value })
                            }
                            placeholder="Enter Locality Name"
                            required
                          />
                        </div>
                      </div>
                      <button type="submit" className="btn btn-primary mt-3">
                        Save Changes
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary mt-3"
                        style={{ marginLeft: "11px" }}
                        onClick={() => {
                          setEditID(null);
                          setIsEdit(false);
                        }}
                      >
                        Cancel
                      </button>
                    </form>
                  </section>
                ) : (
                  <section className="chartBox_area">
                    <DataTable
                      columns={columns}
                      data={filterText ? filteredData : designations}
                      pagination
                      responsive
                      highlightOnHover
                      noDataComponent="No localities found"
                    />
                  </section>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageLocality;
